import React from "react";

import { dateToString, stringToDate, toDateString } from "utils/DateUtils";
import DatePicker from "utils/elements/DatePicker";
import { ChangeEvent } from "utils/history/Event";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
	InformationRight,
	InformationRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { DateField } from "core/field/FieldService";
import { isEmpty } from "utils/Utils";

export type DateInputProps = {
	field: DateField;
	editable: boolean;
	rights: InformationRights;

	onChange: (event: ChangeEvent, valid: boolean) => void;
};

const DateInput: React.FC<DateInputProps> = (props: DateInputProps) => {
	function isValid(value: string): boolean {
		return props.field.required ? !isEmpty(value) : true;
	}

	function onChange(date: Date | null): void {
		const newValue = dateToString(date);
		const change = new ChangeEvent("/value", props.field.value, newValue);
		props.onChange(change, isValid(newValue));
	}

	return (
		<Grid
			item
			container
			xs={12}
			md={6}
			columnSpacing={2}
			alignItems="center">
			<Grid item xs={12} sm={6}>
				<Typography variant="subtitle2" sx={{ wordWrap: "break-word" }}>
					{props.field.name}
					{props.field.required && " *"}
				</Typography>
			</Grid>
			<Grid item xs={12} sm={6}>
				{props.editable &&
				props.rights[props.field.uuid][InformationRight.WRITE] ? (
					<DatePicker
						inputProps={{
							variant: "standard",
							fullWidth: true,
							required: props.field.required,
							error: !isValid(props.field.value),
							InputLabelProps: {
								shrink: true
							}
						}}
						value={stringToDate(props.field.value)}
						onChange={onChange}
					/>
				) : (
					<Typography variant="body2" sx={{ wordWrap: "break-word" }}>
						{toDateString(props.field.value)}
					</Typography>
				)}
			</Grid>
		</Grid>
	);
};

export default DateInput;
